import { Box, Skeleton } from "@mui/material"

const PreviewCardSkeleton=()=>{
    return (
        <Box sx={{width: "100%", display:"flex"}}>

        <Box sx={{marginTop:"30px", width:"25%", marginLeft:"3%"}}>
            
            <Box sx={{ pt: 0.5 }}>
                          <Skeleton width="98%" />
                          <Skeleton width="80%" />
             </Box>
              <Skeleton variant="rectangular" width={"100%"}  height={"70vh"}  />
          
          
        </Box>

        <Box sx={{marginTop:"30px", width:"45%", marginLeft:"3%"}}>
            
          <Box sx={{ pt: 0.5 }}>
                        <Skeleton width="98%" />
                        <Skeleton width="80%" />
           </Box>
            <Skeleton variant="rectangular" width={"100%"}  height={"70vh"}  />
        </Box>

        <Box sx={{marginTop:"30px", width:"20%", marginLeft:"3%"}}>
            
          <Box sx={{ pt: 0.5 }}>
                        <Skeleton width="98%" />
                        <Skeleton width="80%" />
           </Box>
            <Skeleton variant="rectangular" width={"100%"}  height={"70vh"}  />
        </Box>


    </Box>
    

    )
}

export default PreviewCardSkeleton